import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from './components/AIAnswerBlock';
import Process from './components/Process';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <div className="bg-charcoal-900 font-sans">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <ServicesOverview />
        <AIAnswerBlock />
        <Process />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      {/* Mobile bottom nav spacer */}
      <div className="md:hidden h-16" />
    </div>
  );
}
